export default "__VITE_ASSET__B2xzOya4__"